/**
 * cart-count-bonus-exclude.js
 * ================================================================
 * カートバッジの点数からご購入特典の自動追加分を除外する（Ajax更新後の補正）
 * ================================================================
 *
 * 【背景】
 *   cart.item_count はご購入特典として自動追加された line item も含むため、
 *   カートページの「レジに進む（n個の商品）」（特典除外）やカート追加通知の点数と
 *   ヘッダー／モバイルスティッキーバーのカートバッジの数が食い違っていた。
 *   初期描画は Liquid 側（snippets/cart-count-value.liquid）で除外済みだが、
 *   カート追加などの Ajax 更新後は assets/theme.js の CartCount が
 *   event.cart.item_count をそのまま書き戻すため、そこを上書きで補正する。
 *
 * 【設計】
 *   - assets/theme.js（テーマ本体・アップデートで上書きされるファイル）は変更しない。
 *     FoxTheme.pubsub は subscribers を配列で保持し登録順に呼ぶため、
 *     CartCount より後に購読すれば CartCount の書き込みを上書きできる。
 *     CartCount は customElements.define 時（theme.js 実行中）に購読するので、
 *     theme.js より後に読み込まれるこのファイルは必ず後着になる。
 *   - 対象は data-exclude-bonus 属性が付いた <cart-count> のみ。
 *     クラス名（cart-count--absolute）ではなく属性で指定しているのは、
 *     どの表示を除外対象にしたかをテンプレート側で明示するため。
 *
 * 【判定条件（他の実装と揃えること）】
 *   ・properties._bonus_block_id が付いている line item のみ除外する
 *   ・ギフト包装は明細に出る購入品なので除外しない
 *   ・0 円かどうかは見ない
 *   同一定義の実装箇所：
 *     ・snippets/cart-count-value.liquid（初期描画）
 *     ・sections/main-cart.liquid の checkout_item_count（レジに進むボタン）
 *     ・assets/cart-add-toast.js の countableItemCount()（カート追加通知）
 *
 * 【意図的に触っていないもの】
 *   - documentElement の cart-has-items クラス：CartCount が実カート点数を基に
 *     付与しており、こちらは「カートが空か否か」の判定に使われるため実点数のまま残す。
 *   - aria-label：CartCount 自体が Ajax 更新時に更新していないため、挙動を合わせて据え置き。
 *     （初期描画時は Liquid 側で除外後の値が入る）
 *   - cart-count--blank（カートページ内の件数表示）：現在コメントアウトされており対象外。
 *
 * 【副作用】
 *   特典のみがカートに入っている状態ではバッジが 0 になり非表示になる
 *   （特典は購入条件達成で付くため通常は発生しない）。
 *
 * 最終更新: 2026-08-19
 * ================================================================
 */
(function () {
  'use strict';

  var SELECTOR = 'cart-count[data-exclude-bonus]';

  function countExcludingBonus(cart) {
    if (!cart || !cart.items || !cart.items.length) return Number(cart && cart.item_count) || 0;

    return cart.items.reduce(function (sum, item) {
      var props = item.properties || {};
      if (props._bonus_block_id) return sum;
      return sum + (Number(item.quantity) || 0);
    }, 0);
  }

  function apply(data) {
    if (!data || !data.cart || data.cart.errors) return;

    var count = countExcludingBonus(data.cart);
    var nodes = document.querySelectorAll(SELECTOR);

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];

      if (count > 99) {
        el.innerHTML = '<span class="text-sm-extra">99+</span>';
        el.classList.add('cart-count--small-medium');
      } else {
        el.innerText = String(count);
        el.classList.remove('cart-count--small-medium');
      }

      el.hidden = count === 0;
    }
  }

  function setup() {
    if (
      window.FoxTheme &&
      FoxTheme.pubsub &&
      typeof FoxTheme.pubsub.subscribe === 'function' &&
      FoxTheme.pubsub.PUB_SUB_EVENTS
    ) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, apply);
      return true;
    }
    return false;
  }

  if (!setup()) {
    var retryCount = 0;
    var retryInterval = setInterval(function () {
      retryCount++;
      if (setup() || retryCount > 50) {
        clearInterval(retryInterval);
      }
    }, 100);
  }
})();
